import CustomDatePicker from './CustomDatePicker';

interface DateInputProps {
  label: string;
  placeholder: string;
  value: string;
  error?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  isMandatory?: boolean;
}

function DateInput({
  label,
  placeholder,
  value,
  error,
  onChange,
  disabled = false,
  isMandatory = false,
}: DateInputProps) {
  return (
    <div className="d-block w-100 subscribe__property__content__customfield">
      <div className="subscribe__property__content__label">
        {label}
        {isMandatory && <span className="text-danger"> *</span>}
      </div>
      <CustomDatePicker
        value={value || ''}
        placeholder={placeholder || 'dd/mm/yyyy'}
        disabled={disabled}
        isInvalid={!!error}
        onChange={onChange}
      />
      {error && (
        <div className="subscribe__property__content__error">{error}</div>
      )}
    </div>
  );
}

export default DateInput;
